import {
    chainWalk, checkInactiveOrDeprecatedAsset,
    convertTableJsonToAsset, deepCopyObject, getAliasFromParent, getAssetLabelFromMac,
    getNodeId,
    isResponseCode5xx,
    logOperationalMetric, setAliasToRequest
} from "../../../util/Util";
import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET, ALERT_UPDATE_SUCCESS_ASSET_MESSAGE,
    DEFAULT_VENDOR_ATTRIBUTES, DEPRECATED, getUpdateAssetMessageAlertWithSite,
    LOADING_STRING,
    TESSERACT_ASSET_TYPE
} from "../../../util/Constants";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset,
    updateAssetInPlace
} from "../../../resources/AssetResource";
import {updateConfigurationsInTesseractAssetObject} from "../datamodel/TesseractAssetModelResource";

const metricProcessName = "TESSERACT_DEVICE_DETAILS";
export function fetchTesseractDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: TESSERACT_ASSET_TYPE
    }
    getTesseractDeviceDetails(dispatcher, request)
}

export function setTesseractDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, TESSERACT_ASSET_TYPE, ACTIVE);
    addTesseractDeviceDetails(dispatcher, request, showCustomAlert)
}

export function updateTesseractDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    const request = convertTableJsonToAsset(stateValues, TESSERACT_ASSET_TYPE, ACTIVE);
    updateTesseractAsset(dispatcher, request, showCustomAlert);
}

export function deleteTesseractDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedTesseractDeviceDetails(dispatcher, request)
}

export async function updateTesseractDeviceMac(dispatcher, stateValues, mac, showCustomAlert) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        showCustomAlert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addTesseractDeviceDetails", false, false);
    } else {
        deleteTesseractDeviceDetails(dispatcher, mac);
        setTesseractDeviceDetails(dispatcher, stateValues, showCustomAlert);
    }
}

export async function updateTesseractConfiguration(dispatcher, configurations, mac, showCustomAlert) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const alias = await getAliasFromParent();
    const updatedAsset = updateConfigurationsInTesseractAssetObject(getAssetResult.data.asset, configurations, alias);
    const updateResult = await updateAsset(updatedAsset, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isUpdateSuccess = updateResult.status === 200;
    const isFault = isResponseCode5xx(updateResult.status)
    fetchTesseractDeviceDetails(dispatcher)

    // Log operation
    isUpdateSuccess ? showCustomAlert(ALERT_UPDATE_SUCCESS_ASSET_MESSAGE) : showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
    logOperationalMetric(startTime, metricProcessName, "updateTesseractConfiguration", isUpdateSuccess, isFault);
}

async function addTesseractDeviceDetails(dispatcher, request, showCustomAlert) {
    const startTime = Date.now();
    await setAliasToRequest(request);
    addAsset(request).then(async result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addTesseractDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const isFault = isResponseCode5xx(result.status)
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addTesseractDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addTesseractDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdateAsset = isResponseCode5xx(responseUpdateAsset.status)
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addTesseractDeviceDetails", false, isFaultInUpdateAsset);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addTesseractDeviceDetails", true, false);
        }
        fetchTesseractDeviceDetails(dispatcher);
    });
}

async function updateTesseractAsset(dispatcher, request, showCustomAlert) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
        fetchTesseractDeviceDetails(dispatcher);
        return;
    }
    // Update asset details
    const startTime = Date.now();
    await setAliasToRequest(request);
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isSuccess = updateAssetResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateTesseractDeviceDetails", isSuccess, isFault);
    fetchTesseractDeviceDetails(dispatcher);
}


async function getTesseractDeviceDetails(dispatcher, request) {
    const model = {
        tesseractDeviceInformation: {},
        testConfig: {},
        stowConfig: {},
        macAddressArray: []
    }
    // Fetch static asset details
    await getTesseractDeviceStaticDetails(dispatcher, model, request);
    // TODO:: Fetch asset status details
}

async function getTesseractDeviceStaticDetails(dispatcher, model, request) {
    let pageToken = null;
    // do-while loop until we get a valid pageToken
    do {
        const startTime = Date.now();
        const getAssetsResult = await getAssets(request.nodeId, request.assetType, pageToken)
        const isSuccess = getAssetsResult.status === 200;
        const isFault = isResponseCode5xx(getAssetsResult.status)

        // Log operation
        logOperationalMetric(startTime, metricProcessName, "getTesseractDeviceDetails", isSuccess, isFault);

        if (isSuccess) {
            addTesseractDeviceStaticDetailsToModel(getAssetsResult, model)
            // modifying pageToken to fetch from the latest get assets' result
            pageToken = getAssetsResult.data.pageToken
        } else {
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    } while (pageToken);
    dispatcher({type: "RECEIVE_DATA", data: model});
}

const addTesseractDeviceStaticDetailsToModel = (result, model) => {
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((deviceDetail) => {
            if (deviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(deviceDetail.assetAttributes.mac)
                const mac = deviceDetail.assetAttributes.mac;
                const id = JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;
                model.tesseractDeviceInformation[mac] = {
                    name: deviceDetail.assetAttributes.name,
                    mac: deviceDetail.assetAttributes.mac,
                    ip: deviceDetail.assetAttributes.ip,
                    id: id,
                    port: deviceDetail.assetAttributes.port,
                    vendorAttributes: deviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                    assetStatus: LOADING_STRING,
                    deviceType: deviceDetail.assetAttributes.deviceType,
                    assetType: deviceDetail.assetType,
                    startTime: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).reason, ""),
                }
                model.stowConfig[mac] = chainWalk(() =>
                    JSON.parse(deviceDetail.assetAttributes.stowConfig, []));
                model.testConfig[mac] = chainWalk(() =>
                    JSON.parse(deviceDetail.assetAttributes.testConfig, []));
            }
        });
    }
    return model;
}

async function setAssetLabelDeprecatedTesseractDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteTesseractDeviceDetails", true, false);
            fetchTesseractDeviceDetails(dispatcher);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteTesseractDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function updateTesseractMonitoringDetails(dispatcher, stateValues, mac){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateTesseractMonitoringSchedule(dispatcher, updatedAsset)
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

async function updateTesseractMonitoringSchedule(dispatcher, request) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request,
        chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateTesseractDeviceDetails", isSuccess, isFault);
    fetchTesseractDeviceDetails(dispatcher);
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/network/TesseractDeviceNetworkAPI.js